import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.QBooksShippingSection', {
    sectionName: 'Shipping details',
    dateField: 'Date',
    shipToField: 'Ship to',
    shipViaField: 'Ship via',
    shippingAddressField: 'Shipping address',
    datePlaceholder: 'Enter the date',
    shipToPlaceholder: 'Select a Customer',
    shipViaPlaceholder: 'Enter a text',
    departmentPlaceholder: 'Select {fieldText}',
    shippingAddressPlaceholder: 'Enter the shipping address',
    customFieldPlaceholder: 'Enter a text',
});
